import omit from 'lodash/omit';

import { Theme } from './theme';
import { apiCall, apiClient } from '../client/apiClient';

export const getAllThemesData = async () => {
  const { data } = await apiClient.GET('/themes/');
  return data as any; //FIXME provide return type;
};

export const getThemeById = async (themeId: string) => {
  const data = await apiCall(apiClient.GET('/themes/{themeId}', { params: { path: { themeId } } }));
  return data as Theme;
};

export const createTheme = async (themeDto: Pick<Theme, Exclude<keyof Theme, 'updatedAt' | 'modifiedBy' | '_id'>>) => {
  const { data } = await apiClient.POST('/themes/', { body: themeDto });
  return data as any; //FIXME provide return type;
};

export const updateTheme = async (themeDto: Pick<Theme, Exclude<keyof Theme, 'updatedAt' | 'modifiedBy'>>) => {
  const { data } = await apiClient.PATCH('/themes/{themeId}', {
    params: { path: { themeId: themeDto._id } },
    body: omit(themeDto, '_id')
  });
  return data as any; //FIXME provide return type;
};

export const duplicateTheme = async (id: string, name: string) => {
  const { data } = await apiClient.POST('/themes/{themeId}/duplicate', {
    params: { path: { themeId: id } },
    body: { name }
  });
  return data as any; //FIXME provide return type;
};
